module.exports = __webpack_public_path__ + "static/media/campeonato_04.8cf2a927.jpg";